import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
// import { GetUserTokenHistoryDataTypes } from "../../../../Schema/getUserTokenHistory.types";

export type GetUserTokenHistoryLoadAction = {
  type: string;
  payload: {
    id: number | string;
  };
};

export type GetUserTokenHistoryData = {
  data: {
    full_price: number;
    subsidized_price: number;
    extra_token_price: number;
    userSubscription: {
      id: number;
      user_id: number;
      plan_token_id: number;
      status: string;
      wallet_id: number | null;
      activated_at: string;
      expired_at: string;
      num: string;
    };
    token_details: {
      cached_tokens: number;
      input_tokens: number;
      output_tokens: number;
      total_tokens: string;
      remaining_tokens: number;
      purchase_extra_tokens: number;
      usage_subscription: number;
      usage_free: number;
      usage_wallet_subsidized: number;
    };
    usageTokens: {
      week: number;
      week_start: string;
      usage_tokens: string;
    }[];
  };
};

const GetUserTokenHistory = new ReduxFetchState<GetUserTokenHistoryData | null, {}, any>(
  "getUserTokenHistory",
);

export function* watchGetUserTokenHistory(action: GetUserTokenHistoryLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    let { id } = action.payload;

    const data: GetUserTokenHistoryData = yield axios({
      url: `/api/v1/ai/user/${id}/token/history`,
      method: "GET",
      headers: {
        lang,
      },
    });

    yield put(GetUserTokenHistory.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    yield put(GetUserTokenHistory.actions.loadFailure(e?.response?.data));
  }
}

export function* getUserTokenHistorySagas() {
  yield takeEvery(GetUserTokenHistory.actionTypes.load, watchGetUserTokenHistory);
}

export function useGetUserTokenHistory() {
  const { loading, data, ...getUserTokenHistoryState } = useAppSelector(
    (state) => state.getUserTokenHistory,
  );
  const dispatch = useAppDispatch();

  const dispatchGetUserTokenHistory = useCallback(
    (data: { id: string | number }) => {
      dispatch(GetUserTokenHistory.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getUserTokenHistoryState,
    dispatchGetUserTokenHistory,
    getUserTokenHistoryLoading: loading,
    getUserTokenHistoryData: data,
  };
}

export const {
  actionTypes: getUserTokenHistoryActionsTypes,
  actions: getUserTokenHistoryActions,
  reducer: getUserTokenHistoryReducer,
} = GetUserTokenHistory;
